import React, { useState, useEffect, useRef } from 'react'
import { Button, Spinner, Table } from 'react-bootstrap';
import { DatatableWrapper, Pagination, TableBody, TableHeader } from 'react-bs-datatable';
import fuziElevatorsApi from '../../api/fuziElevatorsApi';
import { ROUTES } from '../../constants/webRouting';
import { Link } from 'react-router-dom';
;

const RelatedListOrderAmc = (props) => {
    const [body, setBody] = useState([]);
    async function init() {
        let userTrackings = await fuziElevatorsApi.fetchOrderAmcsByOrderId(props.order.id);
        //console.log('userTrackings', userTrackings);
        if (userTrackings && userTrackings?.length > 0) {
            setBody(userTrackings);
        } else {
            setBody([]);
        }
    }
    useEffect(() => {
        init();
    }, [props?.refreshOrderAmcList]);

    const header = [
        { title: 'Offer Reference no', prop: 'order_id', cell : (row) =>  <Link to={`${ROUTES.ORDER_AMC.LIST}/${row.order_id}`} state={row}> {row?.offer_name_label} </Link>  },
        { title: 'Offer Name', prop: 'offer_name', cell: (row) => <Link to={`${ROUTES.OFFER.LIST}/${row.id}`} state={row}> {row.offer_name} </Link> },
        { title: 'Offer Status', prop: 'offer_status' },
        { title: 'Assign User', prop: 'owner_id', cell: (row) => <Link to={`${ROUTES.USER}/${row.owner_id}`} state={row}> {row.owner_name} </Link> },
        { title: 'Remarks', prop: 'remarks' },
    ];

    return (
        <>
            <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}
            >
                <Table striped className="related-list-table shadow rounded sm" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {(body && Array.isArray(body)) ?
                        <TableBody />
                        :
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    }
                </Table>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
        </>

    )
};

export default RelatedListOrderAmc
